/* 業者サンプルリクエスト浮動籃 — 2026-05-17 */
(function () {
  'use strict';

  const STORAGE_KEY = 'gtx_sample_request_items';
  const ERP_ENDPOINT = 'https://erp.greentex.jp/portal/business-sample-request';

  // 2026-07-05 客級 i18n：theme.liquid が window.GTX_SMP_ZH を設定（D/E=true→繁中、他=日文）
  const ZH = !!window.GTX_SMP_ZH;
  // R680e：英語版（window.GTX_SMP_EN）を追加
  const EN = !ZH && !!window.GTX_SMP_EN;
  const T = EN ? {
    dup: 'This item is already in your sample list.',
    max50: 'You can request up to 50 items at a time.',
    added: n => 'Added to your sample list (' + n + ' items)',
    empty: 'Your sample list is empty',
    del: 'Remove',
    none: 'No items to request.',
    sending: 'Sending...',
    errGeneric: 'Something went wrong',
    thanks: 'Thank you for your request',
    accepted: 'We have received your sample request.<br>It will be sent <strong style="color:#278473;">SAGAWA freight collect</strong>.',
    reqNo: 'Request no.: #',
    card: 'Please have a business card ready when you receive the samples.',
    close: 'Close',
    failed: 'Sending failed: ',
  } : ZH ? {
    dup: '此品番已在樣品清單中。',
    max50: '一次最多可申請 50 個品番。',
    added: n => '已加入樣品清單（' + n + ' 品番）',
    empty: '樣品清單是空的',
    del: '刪除',
    none: '沒有可申請的品番。',
    sending: '送出中...',
    errGeneric: '發生錯誤',
    thanks: '感謝您的申請',
    accepted: '已受理您的樣品申請。<br><strong style="color:#278473;">SAGAWA 到付</strong>安排寄送。',
    reqNo: '申請編號：#',
    card: '收件時請備妥名片交付，謝謝配合。',
    close: '關閉',
    failed: '送出失敗：',
  } : {
    dup: 'この品番はすでにリクエストリストに追加されています。',
    max50: '一度に請求できるのは 50 品番までです。',
    added: n => 'リクエストリストに追加しました（' + n + ' 品番）',
    empty: 'リクエストリストは空です',
    del: '削除',
    none: 'リクエストする品番がありません。',
    sending: '送信中...',
    errGeneric: 'エラーが発生しました',
    thanks: 'ご連絡ありがとうございます',
    accepted: 'サンプルのご依頼を受け付けました。<br><strong style="color:#278473;">SAGAWA 着払い</strong>にて手配いたします。',
    reqNo: 'リクエスト番号：#',
    card: '受取時に名刺をお預けくださいますようお願いいたします。',
    close: '閉じる',
    failed: '送信に失敗しました：',
  };

  function loadItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) { return []; }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateBadge();
  }

  function updateBadge() {
    const items = loadItems();
    const fab = document.getElementById('gtx-sample-fab');
    const count = document.getElementById('gtx-sample-fab-count');
    if (!fab || !count) return;
    if (items.length > 0) {
      fab.style.display = 'flex';
      count.textContent = items.length;
    } else {
      fab.style.display = 'none';
    }
  }

  // 全域：商品頁的「+ 追加」按鈕呼叫
  window.addToSampleRequest = function (parentCode, productName, imageUrl, handle) {
    const items = loadItems();
    if (items.find(it => it.parent_code === parentCode)) {
      alert(T.dup);
      return;
    }
    if (items.length >= 50) {
      alert(T.max50);
      return;
    }
    items.push({
      parent_code: parentCode,
      product_name: productName,
      image_url: imageUrl,
      handle: handle,
    });
    saveItems(items);
    showToast(T.added(items.length));
  };

  function showToast(msg) {
    const toast = document.createElement('div');
    toast.className = 'gtx-sample-toast';
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(() => toast.classList.add('show'), 10);
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 2200);
  }

  function removeItem(parentCode) {
    const items = loadItems().filter(it => it.parent_code !== parentCode);
    saveItems(items);
    renderPanel();
  }

  function openPanel() {
    document.getElementById('gtx-sample-panel').classList.add('open');
    renderPanel();
  }

  function closePanel() {
    document.getElementById('gtx-sample-panel').classList.remove('open');
  }

  function renderPanel() {
    const items = loadItems();
    const list = document.getElementById('gtx-sample-items-list');
    if (!list) return;
    if (items.length === 0) {
      list.innerHTML = '<p style="color:#888;text-align:center;padding:24px 0;">' + T.empty + '</p>';
      return;
    }
    list.innerHTML = items.map(it => `
      <div class="gtx-sample-item">
        <img src="${it.image_url || ''}" alt="" onerror="this.style.display='none'">
        <div class="gtx-sample-item-info">
          <div class="gtx-sample-item-code">${it.parent_code}</div>
          <div class="gtx-sample-item-name">${it.product_name || ''}</div>
        </div>
        <button class="gtx-sample-item-remove" data-code="${it.parent_code}" aria-label="${T.del}">×</button>
      </div>
    `).join('');
    list.querySelectorAll('.gtx-sample-item-remove').forEach(btn => {
      btn.addEventListener('click', () => removeItem(btn.dataset.code));
    });
  }

  async function submitForm(e) {
    e.preventDefault();
    const form = e.target;
    const items = loadItems();
    if (items.length === 0) {
      alert(T.none);
      return;
    }
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalLabel = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = T.sending;

    // 2026-05-27 Round 90D fix: 業者登入時は use_logged_in_customer フラグで ERP 補完
    const loggedIn = form.dataset.loggedIn === '1';
    let payload;
    if (loggedIn) {
      payload = {
        email: form.email.value.trim(),
        use_logged_in_customer: true,
        items: items,
      };
    } else {
      payload = {
        company: form.company.value.trim(),
        contact_name: form.contact_name.value.trim(),
        email: form.email.value.trim(),
        phone: form.phone.value.trim(),
        ship_address: form.ship_address.value.trim(),
        items: items,
      };
    }

    try {
      const r = await fetch(ERP_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await r.json();
      if (!r.ok) {
        let msg = T.errGeneric;
        if (typeof data.detail === 'string') msg = data.detail;
        else if (data.detail && data.detail.message) msg = data.detail.message;
        throw new Error(msg);
      }
      // 成功（2026-05-19 v2：全サンプル無料・SAGAWA 着払い／¥500 拒否 UI 廃止）
      saveItems([]);
      document.getElementById('gtx-sample-panel-body').innerHTML = `
        <div style="text-align:center;padding:36px 20px;">
          <h3 style="margin:0 0 12px;color:#278473;font-weight:500;font-size:18px;">${T.thanks}</h3>
          <p style="color:#555;margin:0 0 18px;font-size:14px;line-height:1.85;">
            ${T.accepted}
          </p>
          <p style="color:#888;margin:0 0 24px;font-size:12px;line-height:1.7;">
            ${T.reqNo}${data.request_id}<br>
            ${T.card}
          </p>
          <button type="button" id="gtx-sample-close-success" style="padding:10px 32px;background:#278473;color:#fff;border:none;border-radius:2px;cursor:pointer;font-size:14px;letter-spacing:0.04em;">${T.close}</button>
        </div>
      `;
      document.getElementById('gtx-sample-close-success').addEventListener('click', () => {
        location.reload();
      });
    } catch (err) {
      alert(T.failed + err.message);
      submitBtn.disabled = false;
      submitBtn.textContent = originalLabel;
    }
  }

  // 2026-05-27 fix: 商品頁「+ この品番をリクエストに追加」按鈕綁定
  // （旧 product.liquid line 799+ inline binder が散客限定 if 内に閉じ込められていて
　//  業者版 sample card のボタンが click 反応しなかったバグ修正）
  function bindProductSampleButtons() {
    document.querySelectorAll('.product-sample-add-btn').forEach(function(btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function(e) {
        const b = e.currentTarget;
        window.addToSampleRequest(
          b.dataset.parentCode,
          b.dataset.productName,
          b.dataset.imageUrl,
          b.dataset.productHandle
        );
      });
    });
  }

  function init() {
    const fab = document.getElementById('gtx-sample-fab');
    if (fab) fab.addEventListener('click', openPanel);
    const closeBtn = document.getElementById('gtx-sample-panel-close');
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    const form = document.getElementById('gtx-sample-form');
    if (form) form.addEventListener('submit', submitForm);
    const overlay = document.getElementById('gtx-sample-overlay');
    if (overlay) overlay.addEventListener('click', closePanel);
    bindProductSampleButtons();
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
